import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment-timezone';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {},
});

export function getLocale() {
  return i18n.locale;
}

export function setLocale(locale: string) {
  i18n.locale = locale;
  moment.locale(locale);
  localStorage.setItem('lang', locale);
  return i18n.locale;
}

export default i18n;

export function updateLanguageStrings(lang: string, strings: any) {
  // toDo разработать механизм merge переводов

  i18n.mergeLocaleMessage(lang, strings);
}
